module.exports = __webpack_public_path__ + "static/media/px-logo.f619f2b5.png";